import { defineNuxtPlugin } from '#app';
import Swiper from 'swiper/bundle'; // Use the bundle import
import 'swiper/css/bundle'; // Import all Swiper styles

//export default defineNuxtPlugin(() => {
//    return {
//        provide: {
//            initSwiper(el, options = {}) {
//                new Swiper(el, {
//                    ...options,
//                });
//            },
//        },
//    };
//});
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.provide('initSwiper', (el, options) => {
        if (!el) {
            console.error('Element truyền vào initSwiper bị null');
            return null;
        }
        return new Swiper(el, options);
    });
});

